import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";
import type * as lazyIndex from "./lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(
/* webpackChunkName: "NotificationSoundCustomizationTeachingCallout" */ "./lazyIndex"), { name: "NotificationSoundCustomizationTeachingCallout" });

export const LazyNotificationSoundCustomizationTeachingCallout: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.ShowNotificationSoundCustomizationTeachingCallout);
